module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "kbx-title",
    style: (_vm.stepStyle('title')),
    attrs: {
      "klickbox-edit-item": "title",
      "klickbox-edit-label": _vm.$t('edit.canvas.question_title')
    }
  }, [(!_vm.stepPreview.isGeneral) ? _c('text-editor', {
    attrs: {
      "content": _vm.stepPreview.title,
      "change": _vm.onChange,
      "toolbar": true,
      "placeholder": _vm.$t('edit.canvas.question_title_placeholder')
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.stepPreview.title))])], 1)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-02d43056!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/step/Title.vue
 ** module id = 745
 ** module chunks = 1
 **/